import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';

const ContentCourseErrorRateGauge = (props) => (
  <KpiChart
    title="Error report"
    description="The number represents the average error opened per unit."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[0, 1, 2, 3]}
    stepSize={1}
    reverseColors={true}
    onClickHistory={props.onClickHistory}
    formatter={props.formatter}
  />
);

ContentCourseErrorRateGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  formatter: PropTypes.func.isRequired,
};

export default ContentCourseErrorRateGauge;
